import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { runWhere } from "../../lib/runWhere";
import styles from "./RunWhereMark.module.css";

/** A short word on the logotype: cloud, or this computer. */
export function RunWhereMark() {
	const { t } = useTranslation();
	const where = runWhere(typeof window === "undefined" ? "" : window.location.hostname);
	const label = where === "cloud"
		? t("siteAuth.runningCloud", "Running in the cloud")
		: t("siteAuth.runningComputer", "Running on this computer");
	const short = where === "cloud"
		? t("siteAuth.runningCloudShort", "Cloud")
		: t("siteAuth.runningComputerShort", "Computer");

	useEffect(() => {
		const previous = document.title;
		document.title = where === "cloud" ? "AgntSpace Cloud" : "AgntSpace";
		return () => {
			document.title = previous;
		};
	}, [where]);

	return (
		<span className={styles.where} data-where={where} role="status" title={label} aria-label={label}>
			{short}
		</span>
	);
}
